import React, { Children } from 'react';
import { motion } from 'framer-motion';
const cards = [{
  title: 'The Cultural Fracture',
  description: 'An uncompromising look at how ideological division turned into an irreversible abyss.'
}, {
  title: 'The Digital Battlefield',
  description: 'A vision of the war for truth fought within algorithms, platforms, and shadows.'
}, {
  title: 'The Trial of a Generation',
  description: 'A judicial chronicle that exposed the cracks in the soul of American justice.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: 'easeOut'
    }
  }
};
export function InvestigationSection() {
  return <section className="py-24 px-6 md:px-8 bg-charcoal-900" data-id="element-49">
      <div className="max-w-6xl mx-auto" data-id="element-50">
        <motion.div className="max-w-3xl mb-16" initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.3
      }} variants={containerVariants} data-id="element-51">
          <motion.p variants={itemVariants} className="text-patriotRed uppercase tracking-[0.2em] text-sm font-semibold mb-4" data-id="element-52">
            The Narrative
          </motion.p>
          <motion.h2 variants={itemVariants} className="text-3xl md:text-5xl font-bold text-offwhite mb-6 leading-tight" data-id="element-53">
            Sixteen Chapters. One Implacable Truth.
          </motion.h2>
          <motion.p variants={itemVariants} className="text-base md:text-lg font-light text-offwhite-secondary leading-relaxed" data-id="element-54">
            From the ideological abyss that divided a nation to the digital
            trenches where ideas became targets. This is not just a story; it is
            a deep perspective on the forces that seek to silence the American
            spirit.
          </motion.p>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-6" initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} variants={containerVariants} data-id="element-55">
          {cards.map((card, index) => <motion.div key={index} variants={itemVariants} className="bg-charcoal-800 border border-charcoal-700 p-8 hover:border-patriotRed/50 transition-colors duration-500 group relative overflow-hidden" data-id="element-56">
              <div className="absolute inset-0 bg-gradient-to-b from-patriotRed/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" aria-hidden="true" data-id="element-57" />
              <h3 className="text-xl font-bold text-offwhite mb-4 relative z-10 font-serif" data-id="element-58">
                {card.title}
              </h3>
              <p className="text-offwhite-muted font-light leading-relaxed relative z-10" data-id="element-59">
                {card.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}